import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ca from './locales/ca.json';
import es from './locales/es.json';
import en from './locales/en.json';

let savedLocale = 'ca';
try {
  savedLocale = localStorage.getItem('ubxat_locale') || 'ca';
} catch (_) {
  // localStorage is not available (e.g. Jest/jsdom without setup)
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ca: { nav: ca.nav, ui: ca.ui, content: ca.content, traceability: ca.traceability },
      es: { nav: es.nav, ui: es.ui, content: es.content, traceability: es.traceability },
      en: { nav: en.nav, ui: en.ui, content: en.content, traceability: en.traceability },
    },
    lng: savedLocale,
    fallbackLng: 'ca',
    interpolation: { escapeValue: false },
  });

export default i18n;
